let pendingViewName: string | undefined;

export function setPendingDashboardViewName(name: string): void {
  pendingViewName = name;
}

export function clearPendingDashboardViewName(): void {
  pendingViewName = undefined;
}

export function takePendingDashboardViewName(
  viewNames: Array<{ name?: string; id: string }>
): string | undefined {
  if (!pendingViewName) {
    return undefined;
  }

  const match = viewNames.find(view => view.name === pendingViewName);
  if (!match) {
    return undefined;
  }

  pendingViewName = undefined;
  return match.id;
}

export function openNamedDashboardView(
  views: Array<{ name?: string; id: string }> | undefined,
  name: string,
  setSelectedViewId: (viewId: string) => void
): void {
  const match = views?.find(view => view.name === name);
  if (match) {
    clearPendingDashboardViewName();
    setSelectedViewId(match.id);
    return;
  }
  setPendingDashboardViewName(name);
}
